<template>
	<!-- .card -->
	<div class="card" v-bind="$attrs">

		<!-- .card-header -->
		<div class="card-header p-5 pb-2 border-0" 
		v-if="title || $slots.header || $slots['header-title']"  
		:class="header_class">

			<p class="mb-0 h5 fw-bold" v-if="title">
				<i class="fe mr-3 text-secondary" 
				:class="'bi bi-'+icon" v-if="icon"></i>
				{{title}}
				<slot name="header-title"></slot>
			</p>

			<slot name="header"></slot>

		</div>
		<!-- /.card-header -->

		<!-- .card-body -->
		<div class="card-body px-5" 
		v-if="$slots.default">
			<slot></slot>
		</div>
		<!-- /.card-body -->

		<slot name="body"></slot>

		<!-- .card-footer -->
		<div class="card-footer border-top-0 bg-white p-4" 
		:class="footer_class" 
		v-if="$slots.footer">
			<slot name="footer"></slot>
		</div>
		<!-- /.card-footer -->

	</div>
	<!-- /.card -->
</template>


<script>

	export default {

		props: {
			header_class: String,
			footer_class: String,
			title: String,
			icon: String
		}

	}

</script>